import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import { AIFeedbackDetailType } from '@interacta-shared/ui-ai';
import { Index } from '@interacta-shared/util';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AISharedService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = `${inject(ENVIRONMENT).apiBasePath.common}/internal/v2/ai`;

    sendFeedbackToAI(
        messageId: Index,
        like: boolean | undefined,
        feedbacks: AIFeedbackDetailType[] | undefined,
        text: string | undefined,
    ): Observable<void> {
        return this.http.post<void>(
            `${this.baseUrl}/messages/${messageId}/feedback`,
            { like, feedbacks, text },
        );
    }
}
